import constants from "@/utils/constants";
import { ucFirst } from "@/utils/filters";

export default {
    isValidPermissions(userPermissions) {
        return userPermissions && Object.prototype.hasOwnProperty.call(userPermissions, "isCanEditExemptions");
    },
    isAvailableByPermission(appPermissions, itemPermission) {
        if (!itemPermission.permission && itemPermission.isEnterpriseRequired === false) {
            return true;
        } else if (itemPermission.permission && itemPermission.permission.withoutPermission) {
            return true;
        } else if (!itemPermission.permission) {
            return false;
        }

        const itemPermissionKey = Object.keys(itemPermission.permission)[0];
        const itemPermissionValue = Object.values(itemPermission.permission)[0];

        return appPermissions[itemPermissionKey] === itemPermissionValue;
    },
    getPropertyName({ name }) {
        const [entityName, action] = name.split('-').values();

        switch (entityName) {
            case 'enterprise':
                return `isCan${ucFirst(action)}${ucFirst(entityName)}`;
            case 'exemption':
                return `isCan${ucFirst(action)}${ucFirst(entityName)}s`;
        }

    },
    isEnterpriseUser(role) {
        if (!role) {
            return false;
        }

        return role === constants.ROLE_ENTERPRISE_USER;
    },
    isCanAction(userPermissions, action) {
        if (this.isValidPermissions(userPermissions)) {
            return userPermissions[action];
        }

        return false;
    },
    isCanCreateEnterprise(userPermissions) {
        return this.isCanAction(userPermissions, 'isCanCreateEnterprise');
    },
    isCanViewExemptions(userPermissions) {
        return this.isCanAction(userPermissions, 'isCanViewExemptions');
    },
    isCanCreateExemptions(userPermissions) {
        return this.isCanAction(userPermissions, 'isCanCreateExemptions');
    },
    isCanEditExemptions(userPermissions) {
        return this.isCanAction(userPermissions, 'isCanEditExemptions');
    },
    isCanExtendExemptions(userPermissions) {
        return this.isCanAction(userPermissions, 'isCanExtendExemptions');
    },
    isCanViewDues(userPermissions) {
        return this.isCanAction(userPermissions, 'isCanViewDues');
    },
    isCanEditDues(userPermissions) {
        return this.isCanAction(userPermissions, 'isCanEditDues');
    },
    isCanMakeDueEffective(userPermissions) {
        return this.isCanAction(userPermissions, 'isCanMakeDueEffective');
    }
}
